import React, { createContext, useContext, useState } from 'react';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';

const Cards = [
  { id: 'exercises', title: 'Exercises', description: 'Create an exercise', icon: <DirectionsRunIcon />, disabled: false, active: false },
  { id: 'workouts', title: 'Workouts', description: 'Create a workout', icon: <FitnessCenterIcon />, disabled: false, active: false },
  { id: 'training-plan', title: 'Training Plan', description: 'Create a training plan', icon: <AssignmentIcon />, disabled: false, active: true },
  {
    id: 'training-plan-client',
    title: 'Client Training Plan',
    description: 'Create a training plan for specific client',
    icon: <AccessibilityNewIcon />,
    disabled: true,
    active: false,
  },
];

const Exercises = [
  {
    id: 1,
    title: 'Muscle Activation',
    description: 'Learn how this exercise engages key muscle groups.',
    image: 'https://media.giphy.com/media/xT0xeJpnrWC4XWblEk/giphy.gif',
    disabled: false,
    level: 'beginner',
    muscleArea: 'Chest',
  },
  {
    id: 2,
    title: 'Warm-Up Routine',
    description: 'A quick way to prep before a heavy lift.',
    image: 'https://media.giphy.com/media/l0HlOvJ7yaacpuSas/giphy.gif',
    disabled: false,
    level: 'intermediate',
    muscleArea: 'Abs',
  },
  {
    id: 3,
    title: 'Pro Warm-Up',
    description: 'Advanced prep before intense sessions.',
    image: 'https://media.giphy.com/media/l0HlOvJ7yaacpuSas/giphy.gif',
    disabled: false,
    level: 'athlete',
    muscleArea: 'Back',
  },
];

const Types = {
  Exercises: 'exercises',
  Workouts: 'workouts',
  TrainingPlan: 'training-plan',
  TrainingPlanClient: 'training-plan-client',
};

const AiContext = createContext();

export const AiProvider = ({ children }) => {
  const [type, setType] = useState(Types.TrainingPlan);
  const [cards, setCards] = useState(Cards);
  const [exercises, setExercises] = useState(Exercises);

  const [selectedAge, setSelectedAge] = useState('21-30');
  const [selectedDifficulty, setSelectedDifficulty] = useState('intermediate');
  const [selectedGoal, setSelectedGoal] = useState('endurance');
  const [selectedGender, setSelectedGender] = useState('male');

  const [selectedMuscleGroups, setSelectedMuscleGroups] = useState([]);
  const [selectedLevels, setSelectedLevels] = useState([]);

  const selectType = selectedId => {
    if (type !== selectedId) {
      setType(selectedId);
      resetSelectedState();
      setCards(prev => prev.map(x => ({ ...x, active: x.id === selectedId })));
    }
  };

  const resetSelectedState = () => {
    setSelectedDifficulty('intermediate');
    setSelectedMuscleGroups([]);
    setSelectedLevels([]);
    setSelectedGoal('endurance');
    setSelectedGender('male');
    setSelectedAge('21-30');
  };

  return (
    <AiContext.Provider
      value={{
        cards,
        exercises,
        setExercises,
        selectedType: type,
        selectType,
        selectedDifficulty,
        setSelectedDifficulty,
        selectedMuscleGroups,
        setSelectedMuscleGroups,
        selectedGoal,
        setSelectedGoal,
        selectedGender,
        setSelectedGender,
        selectedAge,
        setSelectedAge,
        selectedLevels,
        setSelectedLevels,
      }}
    >
      {children}
    </AiContext.Provider>
  );
};

export const useAiContext = () => {
  const context = useContext(AiContext);
  if (!context) {
    throw new Error('useAiContext must be used within a AiProvider');
  }
  return context;
};
